<div [class.min-w-[56px]]="isXsm$()">
  @if (isXsm$()) {
    <img class="h-[56px]" src="/icons/logos/logo4-512x512.png" />
  } @else {
    <img class="h-[56px]" src="/icons/logos/logo4-large.png" />
  }
</div>
